export default __webpack_public_path__ + "static/media/f.082c483e.png";